<template>
<div class="fb-trigger-entry">
	<div v-if="selectedTrigger!==index" class="layout-row flex flex-center" @click="select">
		<span class="__event">{{event}}</span>
		<span class="flex" >
			<span class="label">Trigger on</span>
			<span class="__trigger">{{triggerOn}}</span>
		</span>
		<span class="flex layout-row" style="max-width: 30%" v-if="trigger.trigger==='visit'">
			<span class="label">in</span>
			<span class="__step text">{{step}}</span>
		</span>
		<span class="flex layout-row" style="max-width: 30%" v-if="trigger.trigger==='click'">
			<span class="label">on</span>
			<span class="__button text">{{button}}</span>
<!--			<span class="label">is clicked</span>-->
		</span>
		<div class="flex"></div>
		<div class="flex-none">
			<v-button class="__delete_btn" v-tippy="{theme:'small'}" @click.stop="$emit('delete', trigger)"
			          content="Remove" flat slim :icon="require('@/assets/img/minus.svg')" />
		</div>

	</div>
	<div v-else class="layout-row flex flex-center"  @click.self.stop="unselect">
		<span class="__event">
	    <v-select class="extra-small select-trigger" :searchable="false" :clearable="false"
	              placeholder="Select an event" :value="trigger.event" v-model="trigger.event"
	              :options="events" label="name" :reduce="x=>x.id" />
		</span>
		<div class="flex layout-column">
			<span class="layout-row flex flex-center" @click.self.stop="unselect">
				<span class="label" @click.self.stop="unselect()">Trigger on</span>
				<span class="__trigger">
			    <v-select class="extra-small select-trigger" :searchable="false" :clearable="false"
			              placeholder="Select a trigger" :value="trigger.trigger" v-model="trigger.trigger"
			              :options="triggers" label="label" :reduce="x=>x.id" />
				</span>
			</span>
			<span class="layout-row flex-center flex margin-t-10" v-if="trigger.trigger==='visit'"
			      @click.self.stop="unselect">
				<span class="label" @click.stop="unselect">in</span>
				<span class="__step flex">
					<v-select class="extra-small select-step" :searchable="false" placeholder="Select a step"
	          v-model="trigger.step_id" :options="steps" label="name" :reduce="x=>x.id">
				    <template v-slot:option="option">
					    <span v-if="!option.id"><b>All steps</b></span>
					    <div v-else class="layout-column">
						    <div class="step-type-tag" v-if="stepTypes.length && stepTypes[option.type -1]">
                  {{ option.type ? stepTypes[option.type -1].title : ''}}
                </div>
						    <span>{{option.name}}</span>
					    </div>
				    </template>
				    <template v-slot:selected-option="option">
					    <span >{{option.name}}</span>
				    </template>
			    </v-select>
				</span>
			</span>
			<span class=" margin-t-10" v-if="trigger.trigger==='click'" @click.self.stop="unselect">
				<span class="layout-row flex flex-center">
					<span class="label" @click.stop="unselect">Button</span>
					<span class="__step flex">
						<v-select class="extra-small select-step" :searchable="false" placeholder="Select a button"
						          v-model="trigger.selector"
						          :options="buttons" label="label" :reduce="x=>x.id">
				    </v-select>
					</span>
				</span>

				<span class="layout-row flex flex-center  margin-t-10" @click.self.stop="unselect"
				      v-if="trigger.selector==='custom'">
					<span class="label" @click.stop="unselect">Selector</span>
					<span class="__step flex">
				    <input-field extra-small v-model="trigger.custom" placeholder=".my-button" />
					</span>
				</span>
			</span>
		</div>


		<div class="" style="width: 20px"></div>
		<div class="flex-none">
			<v-button class="__delete_btn" v-tippy="{theme:'small'}" @click.stop="$emit('delete', trigger)"
			          content="Remove" flat slim :icon="require('@/assets/img/minus.svg')" />
		</div>

	</div>
</div>
</template>

<script>
import {mapGetters} from "vuex";
import VButton from "@/components/base/v-button";
import stepTypes from "@/helpers/stepTypes";
import InputField from "@/components/base/input-field";

export default {
	name: "fb-trigger-entry", components: {InputField, VButton},
	props:['trigger','selectedTrigger','index'],
	data() {
		return {
			active: false,
			stepTypes: stepTypes,
			buttons: [
				{id:'#submit-step',label:'#submit-step'},
				{id:'#next-step',label:'#next-step'},
				{id:'custom',label:'Custom'},
			],
			events: [
				{id:'PageView', name:'PageView'},
				{id:'ViewContent', name:'ViewContent'},
				{id:'Purchase', name:'Purchase',
					defaultTrigger:'purchase',
					disabled:true, info:`<b>Purchase: </b> Purchase event is always triggered when a purchase takes place.`},
				{id:'Lead',name:'Lead',
					defaultTrigger:'optin',
					info:`<b>Lead: </b> Triggered when your customer opts in at any step by providing their email address.`},
				{id:'AddToCart',name:'Add To Cart',
					defaultTrigger:'optin',
					info:`<b>Add To Cart: </b> Triggered when a new lead is detected (similar to <b>Lead</b> event).`},
				{id:'AddPaymentInfo',name:'Add Payment Info',
					defaultTrigger:'attempt',
					info:'<b>Add Payment Info: </b> Triggered when a purchase attempt is started by the user ' +
							'<i>(ie. submitting credit card payment details, or PayPal checkout is started)</i>.'},
				{id:'InitiateCheckout',name:'Initiate Checkout',
					defaultTrigger:'attempt',
					info:`<b>Initiate Checkout: </b> Triggered when a purchase attempt is started by the user`+
							` <i>(ie. submitting credit card payment details, or PayPal checkout is started)</i>, similar to <b>"Add Payment Info"</b> event.`},
			],
		}
	},
	computed: {
		...mapGetters(['getStepDataStore']),
		steps() {
			let s = this.getStepDataStore;
			s = this.sortSteps(s)
			return [{id:0,name:"All steps"}, ...s] || [{id:0,name:"All steps"}];
		},
		triggers() {
			if (['Purchase'].includes(this.trigger.event)) {
				return [
						{id:'attempt',label:'Purchase attempt'},
						{id:'purchase',label:'Purchase'}]
			}
			return [
				{id:'visit',label:'Page visit'},
				{id:'click',label:'Button click'},
				{id:'optin',label:'Optin'},
				{id:'attempt',label:'Purchase attempt'},
				{id:'purchase',label:'Purchase'},
			]
		},
		event() {
			// let events = {"visit":"Page visit","click":"Click","purchase":"Purchase",
			// 	"attempt":"Purchase attempt","lead":"Lead","atc":"Lead"};
			return this.trigger.event || '';
		},
		triggerOn() {
			if (this.trigger.trigger) {
				let events = {"visit":"Page visit","click":"Click","purchase":"Purchase",
					"attempt":"Purchase attempt","optin":"Optin"};
				return events[this.trigger.trigger] || this.trigger.trigger || '';
			}
			return ''
		},
		step() {
			if (this.trigger.step_id) {
				let s = this.getStepDataStore.find(s=>s.id===this.trigger.step_id)
				if (s) return s.name;
				return "unknown step";
			} else {
				return 'All steps'
			}
		},
		button() {
			if (this.trigger.selector==='custom') {
				return this.trigger.custom || '';
			}
			return this.trigger.selector
		},
	},
	methods:{
		sortSteps(arr) {
			function compare(a, b) {
				if (a.order_index < b.order_index) return -1;
				if (a.order_index > b.order_index) return 1;
				return 0;
			}
			return arr ? arr.sort(compare) : [];
		},
		select() {
			console.log("sele")
			this.$emit('select', this.index)
		},
		unselect() {
			console.log("unse")
			this.$emit('select', -1)
		},
	}
}
</script>
<style lang="scss">
.fb-trigger-entry {
	.__delete_btn {
		svg {
			margin: auto;
		}
	}
}
</style>
<style lang="scss" scoped>
.fb-trigger-entry {
	padding: 5px 10px;
	cursor: pointer;
	border-radius: 5px;
	display: flex;
	flex-direction: row;
	align-items: center;
	&:hover {
		background: $light-silver;
	}
	.step-type-tag {
		font-size: 10px;
		display: flex;
		flex-direction: row;
		border: 1px solid whitesmoke;
		padding: 1px 6px;
		border-radius: 4px;
		width: fit-content;
	}
	.__event {
		font-weight: 600;
		width: 33%;
		margin-right: 10px;
	}
	.__trigger {
		white-space: nowrap;
		width: 100%;
	}
	.__step {
		&.text {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 100%;
		}
	}
	.__button {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		&.text {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 100%;
		}
	}
	.label {
		color: $dark-grey;
		margin-right: 5px;
		margin-left: 5px;
		pointer-events: all;
		white-space: nowrap;
	}
	.__delete_btn {
		padding: 2px 6px;
		svg {
			margin: 0;
		}
		&:hover {
			background: $light-grey;
		}
	}
	.select-trigger {
		//width: 160px;
	}
}
</style>
